import { post } from 'features/api';
import { HttpRequestConfig } from '@okapi/http';
import { ApiCancelToken } from 'api';
import {
  FetchProductsResponse,
  FetchRatingsResponse,
  FetchSponsoredProductsProps,
  FetchSponsoredProductsResponse,
  ILoyaltyRewardsRequest,
  ILoyaltyRewardsResponse,
} from '../types';

export const fetchRatings = (
  props: { productsIds: string[] },
  cancelToken?: ApiCancelToken,
  regionCode?: string,
) =>
  post<FetchRatingsResponse>(
    'getRatings',
    props,
    { cancelToken, timeout: 300 } as HttpRequestConfig,
    regionCode ? { regionCode } : null,
  );

export const fetchProductsByIDs = (
  props: { regionCode: string; productsIds: string[] },
  cancelToken?: ApiCancelToken,
) => post<Pick<FetchProductsResponse, 'content'>>('getProductsByIds', props, { cancelToken });

export const fetchSponsoredProducts = (props: FetchSponsoredProductsProps, cancelToken?: ApiCancelToken) =>
  post<Pick<FetchSponsoredProductsResponse, 'content'>>('get-sponsored-products', props, { cancelToken });

export const fetchLoyaltyRewardsRequest = (params: ILoyaltyRewardsRequest) =>
  post<ILoyaltyRewardsResponse>('post-loyalty-rewards', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
